<template>
  <div class="container py-4">
    <SowOocyteCollection />
  </div>
</template>

<script>
import SowOocyteCollection from "@/components/activity/EmbryoCollection.vue";

export default {
  name: "ActivityView",
  components: {
    SowOocyteCollection
  }
};
</script>
